import React from 'react';
import { Button } from './ui/Button';
export function EmotionalClose() {
  const scrollToPricing = () => {
    document.getElementById('pricing-cta-button')?.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  };
  return <section className="py-8 px-4 bg-soft-rose" data-id="element-16">
      <div className="max-w-3xl mx-auto text-center" data-id="element-17">
        <div className="prose prose-lg mx-auto text-warm-brown-dark mb-8" data-id="element-18">
          <p className="text-lg mb-4" data-id="element-19">
            Hay dos versiones de vos en este momento.
          </p>
          <p className="mb-4" data-id="element-20">
            La que cierra esta página y sigue cargando lo que siempre cargó.
          </p>
          <p className="mb-4 font-bold text-deep-rose" data-id="element-21">
            Y la que dice "sí" por primera vez a sí misma.
          </p>
          <p className="mb-6" data-id="element-22">
            La que decide que la cadena de dolor termina aquí. Que sus hijas
            —biológicas o del alma— van a nacer en un linaje más liviano. Más
            libre. Más amoroso.
          </p>
          <h2 className="text-2xl font-bold mb-3" data-id="element-23">
            Esa mujer ya está en vos. Solo necesita permiso.
          </h2>
          <p className="text-xl font-bold text-deep-rose mb-8" data-id="element-24">
            Dale ese permiso hoy.
          </p>

          <div className="mb-8 italic text-warm-brown" data-id="element-25">
            <p data-id="element-26">Con amor y raíces,</p>
            <p className="font-bold mt-2 font-heading text-xl" data-id="element-27">
              Creadora de Alquimia del Linaje
            </p>
          </div>
        </div>

        <div className="bg-white p-6 rounded-3xl shadow-soft" data-id="element-28">
          <Button onClick={() => window.open('https://pagos.indigo33.shop/cart/43934466932824:1', '_blank')} className="text-lg px-6 py-4 w-full md:w-auto mb-4" data-id="element-29">
            🌹 QUIERO EMPEZAR MI SANACIÓN AHORA
          </Button>

          <h3 className="text-lg font-bold text-warm-brown-dark mb-4" data-id="element-30">
            Por solo $19.999 — Acceso inmediato
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-xs text-warm-brown text-left max-w-lg mx-auto" data-id="element-31">
            <p className="flex items-center gap-2" data-id="element-32">
              <span data-id="element-33">🔒</span> Pago 100% seguro
            </p>
            <p className="flex items-center gap-2" data-id="element-34">
              <span data-id="element-35">✉️</span> Acceso inmediato tras la compra
            </p>
            <p className="flex items-center gap-2" data-id="element-36">
              <span data-id="element-37">🛡️</span> Garantía total de 7 días sin preguntas
            </p>
            <p className="flex items-center gap-2" data-id="element-38">
              <span data-id="element-39">📱</span> Compatible con celular, tablet y computadora
            </p>
          </div>
        </div>
      </div>
    </section>;
}